import type { Store } from '../store/useStore'
import { genreOf } from './genre'
import { isSelfOrderEnabled } from './features'

/**
 * #1979 スタッフ・店長の「注文管理を使う店か」と「ログイン後の着地先」。
 *
 * ## なぜ 1 か所にまとめるか
 *
 * 下部ナビ (`StaffTabBar`) と着地先 (`StoreDashboard` のリダイレクト) が**別々に
 * 決めていると必ずズレる**。実際にズレた — ナビから注文管理を外した販売の店で、
 * 着地先だけ `/store/orders/` のままになり、**ナビから辿れない画面に降ろされて
 * いた**。注文が発生しない業態なので、常に空の画面が最初に出る。
 */

/**
 * 注文管理をその店で使うか。
 *
 * セルフオーダー店（客が卓から注文する）か、店頭受け取り店（takeout）だけ。
 * どちらでもない店（イベントの物販ブース等）は注文が一件も発生しないので出さない。
 */
export function staffShowsOrders(store: Store | null | undefined): boolean {
  if (!store) return false
  return (isSelfOrderEnabled() && store.orderingMode === 'self-order') || !!store.takeoutEnabled
}

/**
 * ログイン直後に出す画面。
 *
 * **注文を使う店は注文管理、そうでない店はレジ。** 販売・体験は会計が仕事の
 * 中心なので、レジに降りるのが自然（オーナー側も「会計のみの店はレジが唯一の
 * 導線」としている）。
 */
export function staffLandingPath(storeId: string, store: Store | null | undefined): string {
  return staffShowsOrders(store)
    ? `/store/orders/${storeId}`
    : `/store/cashier/${storeId}`
}

/** 参考: 業態を見たい呼び出し側のために再輸出する。 */
export function storeGenre(store: Store | null | undefined) {
  return store ? genreOf(store) : undefined
}
